import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Wraps all routed pages with browser history support and scroll restoration.
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./routes/AppRoutes";
import { ScrollToTop } from "./components/ScrollToTop";
export function App() {
    return (_jsxs(BrowserRouter, { children: [_jsx(ScrollToTop, {}), _jsx(AppRoutes, {})] }));
}
